// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3UL3H","addWidgetButton":"Header_addWidgetButton__1ucyJ","dashboardTabs":"Header_dashboardTabs__10QtY","active":"Header_active__8mLsO"};